var pageFaqEndpoint = '/api/fetch_page_faq';
var FAQ_HOST = '/apps/faq-host';
var locale = window.Shopify?.locale || '';
var page = window.location.href

if (page !== undefined) {
  fetch(FAQ_HOST + pageFaqEndpoint + '?page_link=' + page + '&locale=' + locale, {
    method: "GET",
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(function (response) {
    if (response.status === 200) {
      response.json().then(function (data) {
        if (data.response.status == 200) {
          const PageWidget = data.response.data.widget;
          if(PageWidget){
            if (!PageWidget) return console.warn("Widget data is missing or invalid.");
            createPageFaqHeader(PageWidget)
          }

          if(data.response.data.faq_type === "group_view") {
            groupQueAns = data.response.data.product_faq;
            pageGroupView(groupQueAns, PageWidget);
            const allQuestions = groupQueAns.flatMap(group => group.questions);
            addFaqJsonLdToHead(allQuestions, data.response.data.faq_schema);
          }else{
            faqQuesAns = data.response.data.product_faq.sort((a, b) => (a.order || 0) - (b.order || 0))
            pageListView(faqQuesAns, PageWidget);
            addFaqJsonLdToHead(faqQuesAns, data.response.data.faq_schema);
          }
          const questionElements = document.querySelectorAll('.page-question p');
          questionElements.forEach((element) => {
            element.style.fontSize = PageWidget.qTextSize;
            element.style.fontWeight = PageWidget.qTextWeight;
          });
        }
      });
    }
  })
  .catch(function (err) {
    console.log(err)
  });
}
// GroupView Funcation
function pageGroupView(groupQueAns, PageWidget) {
  var groupview = "";

  groupQueAns.forEach((group, i) => {
    groupview += `<p><b>${group.name}</b></p>`;
    group.questions.forEach((que, idx) => {
      groupview += `
        <hr style="margin: 0;">
        <div id="${i}-question-${idx}" style="cursor:pointer;">
          <div class="page-question">
            <p>${que.question}</p>
            <p class="toggleSymbol">➕</p>
          </div>
          <div class="page-answer">
            ${que.answer}
          </div>
        </div>`;
    });
  });

  document.getElementById("PageFaqQues").innerHTML = groupview;
  var qsec = document.querySelectorAll(".page-question");

  qsec.forEach((questionElement) => {
    questionElement.addEventListener("click", function () {
      var answer = this.nextElementSibling;
      var symbol = this.querySelector(".toggleSymbol");
      if (answer.style.display === "block") {
        answer.style.display = "none";
        symbol.innerHTML = "➕";
      } else {
        answer.style.display = "block";
        symbol.innerHTML = "➖";
      }
    });
  });

  var faqSection = document.getElementById("PageFaqSection");
  faqSection.style.display = "block";
  faqSection.style.padding = `${PageWidget.secTop}px ${PageWidget.secRight}px ${PageWidget.secBottom}px ${PageWidget.secLeft}px`;
}

// List View Funcation
function pageListView(faqQuesAns, PageWidget) {
  var fsec = "";
  faqQuesAns.map((f, i) => {
    fsec += `<hr style="margin: 0;"><div id="${i}" style="cursor:pointer;">
        <div class="page-question">
            <p>${f.question}</p>
            <p class="toggleSymbol">➕</p>
        </div>
        <div class="page-answer">${f.answer}</div>
      </div>`;
  })
  fsec += `<hr style="margin: 0;">`
  document.getElementById("PageFaqQues").innerHTML = fsec;
  var qsec = document.getElementsByClassName("page-question");
  for (var pIndex = 0; pIndex < faqQuesAns.length; pIndex++) {
    qsec[pIndex].addEventListener("click", function () {
      var answer = this.nextElementSibling;
      var symbol = this.querySelector(".toggleSymbol");
      if (answer.style.display === "block") {
        answer.style.display = "none";
        symbol.innerHTML = "➕";
      } else {
        answer.style.display = "block";
        symbol.innerHTML = "➖";
      }
    });
  }
  var faqSection = document.getElementById("PageFaqSection");
  faqSection.style.display = "block";
  faqSection.style.padding = `${PageWidget.secTop}px ${PageWidget.secRight}px ${PageWidget.secBottom}px ${PageWidget.secLeft}px`;
}

function addFaqJsonLdToHead(faqs, faq_schema) {
  if (!faq_schema || faqs.length === 0) {
    return; // Do not add the script if faq_schema is false or there are no FAQs
  }
  // Create a new <script> element
  const scriptElement = document.createElement('script');
  scriptElement.type = 'application/ld+json';

  // Construct JSON-LD content dynamically
  const jsonLdContent = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  // Set the JSON-LD content as the innerHTML of the script element
  scriptElement.innerHTML = JSON.stringify(jsonLdContent);

  // Append the script element to the <head> tag
  document.head.appendChild(scriptElement);
}

var demoques = document.getElementsByClassName("page-demo-question");
for (var pIndex = 0; pIndex < demoques.length; pIndex++) {
  demoques[pIndex].addEventListener("click", function () {
    var answer = this.nextElementSibling;
    var symbol = this.querySelector(".toggleSymbol");

    if (answer.style.display === "block" || answer.style.display === "") {
      answer.style.display = "none";
      symbol.innerHTML = "➕";
    } else {
      answer.style.display = "block";
      symbol.innerHTML = "➖";
    }
  });
}

// Create Page Faq Header HTML
function createPageFaqHeader(pageWidgetData) {
  const faqHeadSec = document.getElementById("pageFaqHeadSec");
  if (!faqHeadSec) return console.warn("Element with id 'faqHeadSec' not found.");

  // Clear any existing content
  faqHeadSec.innerHTML = "";
  faqHeadSec.className = "text-center";

  // Create the dynamic heading tag
  const headingTag = document.createElement(pageWidgetData.headingTag || "h1");
  headingTag.textContent = pageWidgetData.mainTitle;
  faqHeadSec.appendChild(headingTag);

  // Create the subtitle paragraph
  const subtitle = document.createElement("p");
  subtitle.textContent = pageWidgetData.subTitle;
  faqHeadSec.appendChild(subtitle);
}
